export const environment = {
	api: 'https://test.rodabernat.es/api',
  production: false,
  googleMapsApiKey: 'AIzaSyByfUA6lXPdsX9f04nQZI9xAD_gpeqpdi0'
};
